/**
 * Mensajes de validación compartidos.
 * Espejo de `apps/web-real-estate/src/shared/constants/messages` (MESSAGES_VALIDATE),
 * fuente única para front (RHF) y back (nestjs-zod).
 */
export const MESSAGES = {
  REQUIRED: 'Este campo es obligatorio',
  EMAIL: 'Correo electrónico inválido',
  CHECKBOX: 'Debe seleccionar al menos una opción',
  CUI_INVALID: 'El número de CUI/DPI no es válido',
  NIT_INVALID: 'El NIT no es válido',
  MIN: (n: number) => `Debe tener al menos ${n} caracteres`,
  MAX: (n: number) => `Debe tener como máximo ${n} caracteres`
} as const
